"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = Row;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = require("../Box");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Styled components
// -------------------------------------------------------------------------------------------------

// Make sure that we use styled-component's own typing for the `as` prop.
const Base = _styledComponents.default.div`
  ${_Box.base};

  display: flex;

  ${p => typeof p.align !== undefined && align(p.align)};

  ${p => typeof p.justify !== undefined && justify(p.justify)};

  ${({
  space,
  theme
}) => typeof space !== 'undefined' && (0, _styledComponents.css)`
      & > :not(:first-of-type) {
        margin-left: ${(0, _polished.rem)(theme.spacing[space])};
      }
    `};

  ${p => typeof p.childWidth !== 'undefined' && (0, _styledComponents.css)`
      & > * {
        flex-basis: ${p.childWidth}%;
      }
    `};
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 * A basic layout component that helps align its children as in a row.
 */
function Row({
  align,
  children,
  equal,
  justify,
  space,
  testId,
  ...rest
}) {
  let childWidth;
  const length = children === null || children === void 0 ? void 0 : children.length;
  if (equal && length) childWidth = 100 / length;
  return /*#__PURE__*/_react.default.createElement(Base, _extends({
    align: align,
    childWidth: childWidth,
    "data-testid": testId,
    justify: justify,
    space: space
  }, rest), children);
}

//
// Private functions
// -------------------------------------------------------------------------------------------------

function align(direction) {
  switch (direction) {
    case 'end':
    case 'start':
      return (0, _styledComponents.css)`
        align-items: ${`flex-${direction}`};
      `;
    default:
      return (0, _styledComponents.css)`
        align-items: ${direction};
      `;
  }
}
function justify(direction) {
  switch (direction) {
    case 'end':
    case 'start':
      return (0, _styledComponents.css)`
        justify-content: ${`flex-${direction}`};
      `;
    case 'stretch':
      return (0, _styledComponents.css)`
        justify-content: center;

        & > * {
          flex-grow: 1;
        }
      `;
    default:
      return (0, _styledComponents.css)`
        justify-content: ${direction};
      `;
  }
}